// frontend\src\components\Loader.js
const Loader = () => {
  return (
    <div className="container mt-5 text-center">
      <div className="spinner-border text-primary" role="status"></div>
      <p className="mt-2">Загрузка данных...</p>
    </div>
  );
};

export default Loader;
